document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.column.slider');
  sliders.forEach(slider => {
    const prevBtn = slider.closest('.shop-category-slider-container').querySelector('.slider-btn.prev');
    const nextBtn = slider.closest('.shop-category-slider-container').querySelector('.slider-btn.next');

    if(prevBtn) prevBtn.addEventListener('click', () => scrollSlider(slider, -1));
    if(nextBtn) nextBtn.addEventListener('click', () => scrollSlider(slider, 1));
  });

  function scrollSlider(slider, direction) {
    const card = slider.querySelector('.shop-category-image-wrapper');
    if(!card) return;

    const gap = parseInt(getComputedStyle(card).marginRight) || 0;
    const cardWidth = card.getBoundingClientRect().width + gap;
    slider.scrollBy({ left: cardWidth * direction, behavior: 'smooth' });
  }
});